import React from 'react';
import { EJedeaiMetadataXSource } from '@sgdocs/client';
import { RichJsonSchemaWidget } from './RichJsonSchemaWidget';

export interface WidgetXSourceFactoryProps {
  onChange: (newValues: string) => void;
  value: any;
  placeholder: string;
  readonly: boolean;
}

export const SparkMontageJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.SPARK_MONTAGE}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const SparkMontageSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.SPARK_MONTAGE_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const SparkProductIssueJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.SPARK_PRODUCT_ISSUE}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const SparkProductIssueSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.SPARK_PRODUCT_ISSUE_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const EliotBasketJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.ELIOT_BASKET}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const EliotBasketSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.ELIOT_BASKET_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const EliotFlowJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.ELIOT_FLOW}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const EliotFlowSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.ELIOT_FLOW_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const XOneDealJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.X_ONE_DEAL}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const XOneDealSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.X_ONE_DEAL_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const GalaxyProductJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.GALAXY_PRODUCT}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const GalaxyProductSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.GALAXY_PRODUCT_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroCounterpartyJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_COUNTERPARTY}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroCounterpartySearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_COUNTERPARTY_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroCareCounterpartyJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_CARE_COUNTERPARTY}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroCareCounterpartySearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_CARE_COUNTERPARTY_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroLegalEntityJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_LEGAL_ENTITY}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const MaestroLegalEntitySearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.MAESTRO_LEGAL_ENTITY_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const TermsheetControlJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.TERMSHEET_CONTROL}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};

export const TermsheetControlSearchJsonSchemaWidget = ({
  onChange,
  value,
  placeholder = '',
  readonly = false,
}: WidgetXSourceFactoryProps): JSX.Element => {
  return (
    <RichJsonSchemaWidget
      xSource={EJedeaiMetadataXSource.TERMSHEET_CONTROL_SEARCH}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      readonly={readonly}
    />
  );
};
